import { Link } from "react-router-dom";
import { Phone, ClipboardList } from "lucide-react";
import { useSite } from "@/lib/SiteContext";
import { isPlaceholder } from "@/lib/content";

export default function MobileCtaBar() {
  const { settings } = useSite();
  const phone = settings.phone;
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-white/10 bg-navy/95 backdrop-blur-md md:hidden" data-testid="mobile-cta-bar">
      {!isPlaceholder(phone) ? (
        <a href={`tel:${phone.replace(/\s/g, "")}`} className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-white" data-testid="mobile-call-button">
          <Phone className="h-4 w-4 text-teal-400" /> Call Now
        </a>
      ) : (
        <Link to="/contact" className="flex items-center justify-center gap-2 py-4 text-sm font-semibold text-white" data-testid="mobile-call-button">
          <Phone className="h-4 w-4 text-teal-400" /> Call Now
        </Link>
      )}
      <Link to="/quote" className="flex items-center justify-center gap-2 bg-teal-600 py-4 text-sm font-semibold text-white" data-testid="mobile-quote-button">
        <ClipboardList className="h-4 w-4" /> Get a Quote
      </Link>
    </div>
  );
}
